import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Particles from "particles.vue3";
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import '@/util/axios.config.js'
// 手机端公共适配（≤768px）：导航横滑、用户区、卡片/弹窗不溢出。只在小屏生效。
import '@/styles/mobile.css'
// import 'element-plus/lib/theme-chalk/index.css';
import { Button } from 'element-plus';
// 导入Element Plus中文语言包
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'


const app = createApp(App)

// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 配置应用
app.use(Particles)
   .use(ElementPlus, {
       locale: zhCn,
   })
   .use(store)
   .use(router)
   .mount('#app')
